import { styled } from 'styled-components';
const StyledDescriptionTerm = styled.dt.withConfig({
  componentId: "aui__sc-q2nqrj-0"
})(["align-items:center;gap:0.25rem;text-align:left;padding-top:0.25rem;"]);
export { StyledDescriptionTerm };